<template>
  <div class="animated">
    <v-server-table
      v-if="collection"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      id="field-server-table"
      class="w-100"
      ref="table"
    >
      <span slot="name" slot-scope="{row}">
        {{ row.name }}
      </span>

      <span slot="customer_grower" slot-scope="{row}">
        {{ row.customer_grower.name }}
      </span>

      <span slot="actions" slot-scope="{row}">
        <b-button
          variant="warning"
          class="px-1 py-0 mr-1 text-white"
          :to="'/customer-growers/' + row.customer_grower_id + '/fields/' + row.id + '/edit'"
        >
          <i class="fa fa-pencil" />
        </b-button>
        <b-button
          variant="danger"
          class="px-1 py-0 mr-1 text-white"
          @click="showDeleteModal(row.id)"
        >
          <i class="fa fa-trash" />
        </b-button>
      </span>
    </v-server-table>
  </div>
</template>

<script>
import Vue from 'vue'
import BaseServerTable from '@/components/shared/BaseServerTable'
import { ServerTable } from 'vue-tables-2'
import CustomerFieldCollection from '@/collections/crm/CustomerFieldCollection'
import CustomerFieldModel from '@/models/crm/CustomerFieldModel'

Vue.use(ServerTable)

export default {
  name: 'CustomerFieldServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => {
        return new CustomerFieldCollection()
      }
    },
    show_columns: {
      type: Array,
      default: function () {
        return [
          'name',
          'customer_grower',
          'actions'
        ]
      }
    },
    filterable: {
      type: Array,
      default: function () {
        return [
          'name',
          'customer_grower'
        ]
      }
    },
    sortable: {
      type: Array,
      default: function () {
        return [
          'name',
          'customer_grower'
        ]
      }
    },
    customer_grower_id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      table_config: _.merge(
        this.getDefaultTableConfig(), {
          options: {
            headings: {
              name: 'Field',
              customer_grower: 'Grower'
            }
          }
        }
      )
    }
  },
  methods: {
    prepareCollectionFilter (filter) {
      filter.filterEquals('customer.id', this.$store.getters.getAuthCustomerID)
      filter.filterEquals('customer_grower_id', this.customer_grower_id)
      return filter
    },

    showDeleteModal (id) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this Field?', {
        title: 'Delete Field',
        modalClass: ["modal-danger"],
        size: "sm",
        okVariant: "danger",
        okTitle: "YES",
        cancelTitle: "NO",
        footerClass: "p-2",
        centered: true,
      })
      .then(confirm => {
        if (confirm) {
          const model = new CustomerFieldModel({ id })
          model.delete().then(() => {
            this.$bvToast.toast('', {
              title: 'Field deleted',
              variant: 'success'
            })

            this.$refs.table.refresh()
          })
        }
      })
    }
  }
}
</script>
